import type { TError, TMentionUser } from '@onesource/schemas';
import { keepPreviousData, useQuery } from '@tanstack/react-query';

import { fetchMentionUsers } from './fetch-mention-users';

/**
 * Member search across all users (members-panel scope). Private users and users
 * blocked in either direction are excluded server-side. Pass `excludeSelf` to also
 * leave the caller out (e.g. the block search — you can't block yourself).
 */
export const useSearchMentionUsersQuery = (query: string, options?: { enabled?: boolean; excludeSelf?: boolean }) => {
  const excludeSelf = options?.excludeSelf ?? false;
  return useQuery<TMentionUser[], TError>({
    queryKey: ['mention', 'users', query, { excludeSelf }],
    queryFn: () => fetchMentionUsers(query, { excludeSelf }),
    enabled: options?.enabled ?? true,
    // Keep the previous term's results on screen while the next term loads.
    placeholderData: keepPreviousData,
    staleTime: 60 * 1000,
  });
};
